module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.active,
      "custom-class": (_vm.modalClass + " responsive-modal"),
      "close-on-click-modal": _vm.modalCloseOnClick,
      "show-close": _vm.modalShowClose,
      "close-on-press-escape": _vm.modalCloseOnPressEscape
    },
    on: {
      "update:visible": function($event) {
        _vm.active = $event
      },
      "close": _vm.onClose
    }
  }, [(Object.keys(_vm.content).length) ? _c('div', [_c(_vm.content, _vm._b({
    tag: "component",
    on: {
      "close": _vm.onClose
    }
  }, 'component', _vm.modalProps, false))], 1) : _c('div', [_vm._v("No content")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8ebda7","hasScoped":false}!./src/app/components/modal/modal.html
// module id = 2929
// module chunks = 1